import React from 'react'
import {
  Card,
  CardContent,
  CardMedia,
  Typography,
  Button,
  Box
} from '@mui/material'
import { useNavigate } from 'react-router'
import { authorUrl } from '../../helpers/url'

const AuthorCard = ({ author, index }) => {
  const navigate = useNavigate()

  const handleAuthorClick = author => {
    navigate(authorUrl(author?.slug))
  }

  return (
    <Card
      onClick={() => handleAuthorClick(author)}
      data-test={`author-carousel-card-${index}`}
      sx={{
        maxWidth: 280,
        border: '1px solid #E0E0E0',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        p: 2,
        mx: 'auto',
        cursor: 'pointer',
        boxShadow: 'none'
      }}
    >
      <Box
        sx={{
          width: 200,
          height: 248,
          overflow: 'hidden'
        }}
      >
        <CardMedia
          component='img'
          image={author.image.imgUrl}
          alt={author.image.altText}
          data-test={`author-carousel-image-${index}`}
          sx={{
            width: '100%',
            height: '100%',
            objectFit: 'cover'
          }}
        />
      </Box>

      <CardContent
        sx={{
          textAlign: 'center'
        }}
      >
        <Typography variant='h6' component='div' fontWeight='bold' data-test={`author-carousel-name-${index}`}>
          {author.name}
        </Typography>
        <Typography variant='body2' color='text.secondary' mb={2} data-test={`author-carousel-title-${index}`}>
          {author.title}
        </Typography>
        <Button
          variant='outlined'
          size='small'
          data-test={`author-carousel-button-${index}`}
          sx={{
            borderRadius: 2,
            textTransform: 'none',
            borderColor: '#E0E0E0'
          }}
        >
          See Author
        </Button>
      </CardContent>
    </Card>
  )
}

export default AuthorCard
